"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ElasticSearchAPIInfo = require("crm_data/elasticSearch/api/ElasticSearchAPIInfo");

var _ElasticSearchStore = _interopRequireDefault(require("crm_data/elasticSearch/ElasticSearchStore"));

var _derefSearchText = _interopRequireDefault(require("crm_data/dependencies/derefSearchText"));

var _AssociationOptionsDependencyHelpers = require("crm_data/associations/AssociationOptionsDependencyHelpers");

var _LoadingStatus = require("crm_data/flux/LoadingStatus");

var _immutable = require("immutable");

var _SearchAPIQuery = _interopRequireDefault(require("crm_data/elasticSearch/api/SearchAPIQuery"));

var _ElasticSearchConstants = require("customer-data-objects/search/ElasticSearchConstants");

var _ElasticSearchValidation = require("crm_data/elasticSearch/ElasticSearchValidation");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var makeElasticSearchUISelectDependency = function makeElasticSearchUISelectDependency(SubjectStore, objectType) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var getSearchText = opts.getSearchText || _derefSearchText.default;
  var stores = opts.stores || [];
  var minimumSearchLength = opts.minimumSearchLength || _ElasticSearchConstants.MIN_SEARCH_LENGTH;
  var getFilterGroups = opts.getFilterGroups || _emptyFunction.default;
  return {
    stores: stores.concat([SubjectStore, _ElasticSearchStore.default]),
    deref: function deref(props, state) {
      var searchText = getSearchText(props, state);

      if (!searchText || searchText.length < minimumSearchLength && !(0, _ElasticSearchValidation.isCjkCharacterContained)(searchText)) {
        // TODO if this is EMPTY, the dropdown closes :facepalm:
        return _LoadingStatus.LOADING;
      }

      var searchQuery = _SearchAPIQuery.default.default((0, _immutable.fromJS)({
        query: searchText,
        count: 25
      }), objectType);

      var filterGroups = getFilterGroups(props.objectType);

      if (filterGroups) {
        searchQuery = searchQuery.set('filterGroups', filterGroups);
      }

      var options = {
        cacheTimeout: 5000
      };

      var ids = _ElasticSearchStore.default.get({
        objectType: objectType,
        searchQuery: searchQuery,
        options: options
      });

      var _elasticSearchApiInfo = (0, _ElasticSearchAPIInfo.elasticSearchApiInfo)(objectType),
          dataKey = _elasticSearchApiInfo.dataKey;

      if (!ids || !ids.get(dataKey)) {
        return _LoadingStatus.LOADING;
      }

      return (0, _AssociationOptionsDependencyHelpers.parseMatches)(SubjectStore.get(ids.get(dataKey)));
    }
  };
};

var _default = makeElasticSearchUISelectDependency;
exports.default = _default;
module.exports = exports.default;